import React, { useState } from "react";

const TextForm = (props) => {
  const updateText = () => {
    // console.log(text);

    let newText = text.toUpperCase();

    setText(newText);
    // showAlert("Converted To Upper Case", "Success")
  };
  const clearCase = () => {
    // console.log(text);

    setText("");
  };
  const copy = () => {
    // Get the text field
    let copyText = document.getElementById("myInput");

    // Select the text field
    // copyText.select();
    // copyText.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText.value);
    document.getSelection().removeAllRanges()
    alert("Text Copied to Clipboard Successfully!")

    // Alert the copied text
 
      

  };

  const lowerCase = () => {
    // console.log(text);
    let newText = text.toLowerCase();
    setText(newText);
  };
  const changeIt = (event) => {
    setText(event.target.value);
  };
  const [text, setText] = useState("");
  const [myStyle, setMyStyle] = useState({
    color: "black",
    backgroundColor: "white",
  });
  const [BtnText, setBtnText] = useState("Enable Dark Mode");
  const toggleStyle = () => {
    if (myStyle.color === "white") {
      setMyStyle({
        color: "black",

        backgroundColor: "white",
      });
      setBtnText("Enable Dark Mode");
    
    } else {
      setMyStyle({
        color: "white",
        backgroundColor: "black",
      });
      setBtnText("Disable Dark Mode");
    }
  };

  return (
    <>
      <div className="px-5" style={myStyle}>
        <div className="form-group" style={myStyle}>
          <h5 style={myStyle} className="text-justify text-center pt-2 ">
            Counting so many words are difficult! Isn't it? <br />
            Don't Worry! Text Analyzer will make your task easier!
          </h5>
          <h3 className="pt-3" style={myStyle}>
            {props.headings}{" "}
          </h3>
          <div style={myStyle} className="d-flex flex-row-reverse">
            {/* <button
              onClick={toggleStyle}
              type="button"
              className="btn btn-primary d-flex flex-row-reverse"
              data-bs-toggle="button"
              style={myStyle}
            >
              {BtnText}
            </button> */}
            <div className="form-check form-switch">
              <input
                className="form-check-input "
                type="checkbox"
                id="flexSwitchCheckDefault"
                onClick={toggleStyle}
                style={myStyle}
              ></input>
              <label className="form-check-label " for="flexSwitchCheckDefault">
                {BtnText}
              </label>
            </div>
          </div>

          <label style={myStyle} htmlFor="exampleFormControlTextarea1"></label>
          <textarea
            style={myStyle}
            placeholder="Enter Text"
            className="form-control border border-2 border-danger "
            value={text}
            onChange={changeIt}
            id="myInput"
            rows="5"
          ></textarea>
        </div>
        <button
          disabled={text.length===0}
          className="btn btn-outline-primary my-3 me-3 "
          // style={myStyle}
          onClick={updateText}
        >
          Upper Case
        </button>

        <button

        disabled={text.length===0}
          className="btn btn-outline-primary  me-3 "
          // style={myStyle}
          onClick={lowerCase}
        >
          Lower Case
        </button>

        <button
        disabled={text.length===0}
          // style={myStyle}
          className="btn btn-outline-primary me-3 "
          onClick={clearCase}
        >
          Clear Text
        </button>
        <button
        disabled={text.length===0}
          // style={myStyle}
          className="btn btn-outline-primary my-3 me-3  "
          onClick={copy}
        >
          Copy Text
        </button>
      </div>
      <div style={myStyle} className="px-5">
        

        <h4 style={myStyle} className="primary">
          Your Text Summary Here:
        </h4>
        <p style={myStyle} className="mx-5 ">
          Total Words:{" "}
          <b>
            {
              text.split(/\s+/).filter((element) => {
                return element.length !== 0;
              }).length
            }
          </b>{" "}
          <br /> Total Characters: <b>{text.length}</b> <br /> Total Sentences:{" "}
          <b>
            {
              text.split(".").filter((element) => {
                return element.length !== 0;
              }).length
            }
          </b>{" "}
          <br />
          Time taken to read this text:
          <b> {text.length * 0.008} Mins Approx.</b>
        </p>
        <h4 style={myStyle}>Preview:</h4>
        <div
          style={myStyle}
          className="container border border-2 border-primary my-2 py-3"
        >
          {text}
        </div>
      </div>
    </>
  );
};

export default TextForm;
